import axios from 'axios'

export default axios



// WEBPACK FOOTER //
// ./src/axios.js